import { useAuth0 } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import {
  Backdrop,
  Box,
  CircularProgress,
  Fade,
  Typography,
} from '@mui/material'

let AuthCallback = () => {
  let { isAuthenticated, isLoading } = useAuth0()
  let navigate = useNavigate()

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        // Get the returnTo path from sessionStorage (set by onRedirectCallback)
        let returnTo = sessionStorage.getItem('auth_return_to')
        sessionStorage.removeItem('auth_return_to')

        // Default to /self-paced if no return path specified
        let destination = returnTo || '/self-paced'

        navigate(destination, { replace: true })
      } else {
        // If somehow not authenticated, redirect to homepage
        navigate('/', { replace: true })
      }
    }
  }, [isAuthenticated, isLoading, navigate])

  return (
    <Backdrop
      open={true}
      sx={{
        bgcolor: 'background.default',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Fade in={true} timeout={300}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
          }}
        >
          <CircularProgress
            size={60}
            thickness={4}
            sx={{
              color: 'primary.main',
            }}
          />
          <Typography
            color="text.primary"
            variant="h6"
            sx={{
              fontWeight: 400,
              letterSpacing: '0.02em',
            }}
          >
            Signing you in...
          </Typography>
        </Box>
      </Fade>
    </Backdrop>
  )
}

export default AuthCallback
